import React, { useState, useEffect } from "react";
import '../App.css';
import { Link } from "react-router-dom";
import '../styles/menus.css';

// import components
import LeftMenuItemClosed from './LeftMenuItemClosed.js';

// import assets
import jv_logo_small from '../assets/jv_logo_small.png';
import tasks from '../assets/icon_tasks_gray.png';
import tasks_white from '../assets/icon_tasks_white.png';
import projects from '../assets/icon_projects_gray.png';
import projects_white from '../assets/icon_projects_white.png';
import applications from '../assets/icon_applications_gray.png';
import applications_white from '../assets/icon_applications_white.png';
import funding from '../assets/icon_funding_gray.png';
import funding_white from '../assets/icon_funding_white.png';
import grants from '../assets/icon_grants_gray.png';
import grants_white from '../assets/icon_grants_white.png';
import workflow from '../assets/icon_workflow_gray.png';
import workflow_white from '../assets/icon_workflow_white.png';
import dashboard from '../assets/icon_dashboard.png';
import dashboard_white from '../assets/icon_dashboard_white.png';
import reports from '../assets/icon_reports.png';
import reports_white from '../assets/icon_reports_white.png';
import closeLeftMenuButton from '../assets/closeLeftMenuButton.png';

function storageEventHandler() {
    this.setState({ actualPage: localStorage.getItem("actualPage") || "" });
}

class LeftMenu extends React.Component {
    setActualSection = this.props.setActualSection;

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    isTasksActive(actualSection){
        if(actualSection == "tasks")return true;
        return false;
    }

    isProjectsActive(actualSection){
        if(actualSection == "projects")return true;
        return false;
    }

    isApplicationsActive(actualSection){
        if(actualSection == "applications")return true;
        return false;
    }

    isFundingActive(actualSection){
        if(actualSection == "funding")return true;
        return false;
    }

    isGrantsActive(actualSection){
        if(actualSection == "grants")return true;
        return false;
    }

    isWorkflowActive(actualSection){
        if(actualSection == "workflow")return true;
        return false;
    }

    isSubmissionsActive(actualSection){
        if(actualSection == "submissions")return true;
        return false;
    }

    isFinWorkflowActive(actualSection){
        if(actualSection == "fin_workflow")return true;
        return false;
    }

    isFinDashboardActive(actualSection){
        if(actualSection == "fin_dashboard")return true;
        return false;
    }

    isFinReports(actualSection){
        if(actualSection == "fin_reports")return true;
        return false;
    }

    componentDidMount(){
        this.setState({ actualPage: localStorage.getItem("actualPage") || "" });
        window.addEventListener('storage', storageEventHandler, false);
    }

    render(){
        return(
            <div className="mainLeftMenuClosed">
                <div className="verticalStackCenter" style={{alignItems: "center"}}>
                    <Link className="link" to={"./"} >
                        <img style={{width: "70px"}} src={jv_logo_small}/>
                    </Link>

                    <div className="verticalStack hideVerticalScrollBar" style={{alignItems: "center", position: "relative", overflowY: "scroll", height: "calc(100vh - 27px - 35px - 17px - 10px - 60px)"}}>

                        <div style={{marginTop: "45px"}}>
                            <span className="menuLeftSectionTitle">{"GLOBAL"}</span>
                        </div>

                        <div onClick={() => {this.setActualSection("tasks");localStorage.setItem("actualPageTasks", 0);localStorage.setItem("sortByTasks", "");localStorage.setItem("sortTpTasks", "asc");}}>
                            <LeftMenuItemClosed title={"My Tasks"} link="./" icon={this.isTasksActive(this.props.actualSection) ? tasks_white : tasks} active={this.isTasksActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 0}} />
                        </div>

                        <div style={{marginTop: "38px"}}>
                            <span className="menuLeftSectionTitle">{"PROJECTS"}</span>
                        </div>

                        <div onClick={() => {this.setActualSection("projects");localStorage.setItem("actualPageProjects", 0);localStorage.setItem("sortByProjects", "");localStorage.setItem("sortTpProjects", "asc");}}>
                            <LeftMenuItemClosed title={"Projects"} link="./Projects" icon={this.isProjectsActive(this.props.actualSection) ? projects_white : projects} active={this.isProjectsActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 0}} />
                        </div>

                        <div onClick={() => {this.setActualSection("applications");localStorage.setItem("actualPageApplications", 0);localStorage.setItem("sortByApplications", "");localStorage.setItem("sortTpApplications", "asc");}}>
                            <LeftMenuItemClosed title={"Applications"} link="./Applications" icon={this.isApplicationsActive(this.props.actualSection) ? applications_white : applications} active={this.isApplicationsActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 0}} />
                        </div>

                        <div onClick={() => {this.setActualSection("funding");localStorage.setItem("actualPageFunding", 0);localStorage.setItem("sortByFunding", "");localStorage.setItem("sortTpFunding", "asc");}}>
                            <LeftMenuItemClosed title={"Funding"} link="./Fundings" icon={this.isFundingActive(this.props.actualSection) ? funding_white : funding} active={this.isFundingActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 0}} />
                        </div>

                        <div onClick={() => {this.setActualSection("grants");localStorage.setItem("actualPageGrants", 0);localStorage.setItem("sortByGrants", "");localStorage.setItem("sortTpGrants", "asc");}}>
                            <LeftMenuItemClosed title={"Grants"} link="./Grants" icon={this.isGrantsActive(this.props.actualSection) ? grants_white : grants} active={this.isGrantsActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 0}} />
                        </div>

                        <div onClick={() => {this.setActualSection("workflow");localStorage.setItem("actualPageWorkflow", 0);localStorage.setItem("sortByWorkflow", "");localStorage.setItem("sortTpWorkflow", "asc");}}>
                            <LeftMenuItemClosed title={"Workflow"} link="./Workflow" icon={this.isWorkflowActive(this.props.actualSection) ? workflow_white : workflow} active={this.isWorkflowActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 0}} />
                        </div>

                        <div style={{marginTop: "38px"}}>
                            <span className="menuLeftSectionTitle">{"FINANCE"}</span>
                        </div>

                        <div onClick={() => {this.setActualSection("fin_dashboard");localStorage.setItem("actualPageFinDashboard", 0);localStorage.setItem("sortByFinDashboard", "");localStorage.setItem("sortTpFinDashboard", "asc");}}>
                            <LeftMenuItemClosed title={"Dashboard"} link="./FinDashboard" icon={this.isFinDashboardActive(this.props.actualSection) ? dashboard_white : dashboard} active={this.isFinDashboardActive(this.props.actualSection)} iconStyle={{height: 21}} />
                        </div>

                        <div onClick={() => {this.setActualSection("fin_reports");localStorage.setItem("actualPageSubmissions", 0);localStorage.setItem("sortByFinReports", "");localStorage.setItem("sortTpFinReports", "asc");}}>
                            <LeftMenuItemClosed title={"Reports"} link="./FinReports" icon={this.isFinReports(this.props.actualSection) ? reports_white : reports} active={this.isFinReports(this.props.actualSection)} iconStyle={{height: 20, marginLeft: 0}} />
                        </div>

                        <div onClick={() => {this.setActualSection("submissions");localStorage.setItem("actualPageSubmissions", 0);localStorage.setItem("sortBySubmissions", "");localStorage.setItem("sortTpSubmissions", "asc");}}>
                            <LeftMenuItemClosed title={"Submissions"} link="./Submissions" icon={this.isSubmissionsActive(this.props.actualSection) ? applications_white : applications} active={this.isSubmissionsActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 0}} />
                        </div>

                        <div onClick={() => {this.setActualSection("fin_workflow");localStorage.setItem("actualPageFinWorkflow", 0);localStorage.setItem("sortByFinWorkflow", "");localStorage.setItem("sortTpFinWorkflow", "asc");}}>
                            <LeftMenuItemClosed title={"Workflow"} link="./FinWorkflow" icon={this.isFinWorkflowActive(this.props.actualSection) ? workflow_white : workflow} active={this.isFinWorkflowActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 0}} />
                        </div>

                        <div onClick={() => this.props.setLeftMenuOpened("true")}>
                            <div className="verticalStackCenter" style={{alignItems: "center"}}>
                                <div className="openLeftMenuButton"></div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );
	}
}

export default LeftMenu;